import { render, staticRenderFns } from "./IssueComment.vue?vue&type=template&id=7b516b27&scoped=true"
import script from "./IssueComment.vue?vue&type=script&lang=js"
export * from "./IssueComment.vue?vue&type=script&lang=js"
import style0 from "./IssueComment.vue?vue&type=style&index=0&id=7b516b27&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b516b27",
  null
  
)

export default component.exports